import React, { SVGProps } from 'react';

export const AISingleStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    fill="none"
    viewBox="0 0 36 36"
    {...props}
  >
    <path
      fill="#FF5C00"
      d="M19.26 1.016h-2.52l-3.32 8.63c-.49 1.275-.66 1.69-.9 2.027-.233.328-.52.614-.848.848-.337.24-.75.41-2.025.9l-8.632 3.32v2.52l8.632 3.319c1.274.49 1.688.66 2.025.9.329.233.615.52.848.848.24.337.41.751.9 2.026l3.32 8.63h2.52l3.32-8.63c.49-1.275.66-1.689.9-2.026.233-.328.52-.615.848-.848.337-.24.751-.41 2.025-.9l8.632-3.32v-2.52l-8.632-3.32c-1.274-.49-1.688-.66-2.026-.9a3.599 3.599 0 0 1-.847-.847c-.24-.338-.41-.752-.9-2.026l-3.32-8.631Z"
    />
    <path
      fill="url(#a)"
      d="M19.26 1.016h-2.52l-3.32 8.63c-.49 1.275-.66 1.69-.9 2.027-.233.328-.52.614-.848.848-.337.24-.75.41-2.025.9l-8.632 3.32v2.52l8.632 3.319c1.274.49 1.688.66 2.025.9.329.233.615.52.848.848.24.337.41.751.9 2.026l3.32 8.63h2.52l3.32-8.63c.49-1.275.66-1.689.9-2.026.233-.328.52-.615.848-.848.337-.24.751-.41 2.025-.9l8.632-3.32v-2.52l-8.632-3.32c-1.274-.49-1.688-.66-2.026-.9a3.599 3.599 0 0 1-.847-.847c-.24-.338-.41-.752-.9-2.026l-3.32-8.631Z"
    />
    <path
      fill="url(#b)"
      d="M19.26 1.016h-2.52l-3.32 8.63c-.49 1.275-.66 1.69-.9 2.027-.233.328-.52.614-.848.848-.337.24-.75.41-2.025.9l-8.632 3.32v2.52l8.632 3.319c1.274.49 1.688.66 2.025.9.329.233.615.52.848.848.24.337.41.751.9 2.026l3.32 8.63h2.52l3.32-8.63c.49-1.275.66-1.689.9-2.026.233-.328.52-.615.848-.848.337-.24.751-.41 2.025-.9l8.632-3.32v-2.52l-8.632-3.32c-1.274-.49-1.688-.66-2.026-.9a3.599 3.599 0 0 1-.847-.847c-.24-.338-.41-.752-.9-2.026l-3.32-8.631Z"
    />
    <path
      fill="url(#c)"
      d="M19.26 1.016h-2.52l-3.32 8.63c-.49 1.275-.66 1.69-.9 2.027-.233.328-.52.614-.848.848-.337.24-.75.41-2.025.9l-8.632 3.32v2.52l8.632 3.319c1.274.49 1.688.66 2.025.9.329.233.615.52.848.848.24.337.41.751.9 2.026l3.32 8.63h2.52l3.32-8.63c.49-1.275.66-1.689.9-2.026.233-.328.52-.615.848-.848.337-.24.751-.41 2.025-.9l8.632-3.32v-2.52l-8.632-3.32c-1.274-.49-1.688-.66-2.026-.9a3.599 3.599 0 0 1-.847-.847c-.24-.338-.41-.752-.9-2.026l-3.32-8.631Z"
    />
    <path
      fill="url(#d)"
      d="M19.26 1.016h-2.52l-3.32 8.63c-.49 1.275-.66 1.69-.9 2.027-.233.328-.52.614-.848.848-.337.24-.75.41-2.025.9l-8.632 3.32v2.52l8.632 3.319c1.274.49 1.688.66 2.025.9.329.233.615.52.848.848.24.337.41.751.9 2.026l3.32 8.63h2.52l3.32-8.63c.49-1.275.66-1.689.9-2.026.233-.328.52-.615.848-.848.337-.24.751-.41 2.025-.9l8.632-3.32v-2.52l-8.632-3.32c-1.274-.49-1.688-.66-2.026-.9a3.599 3.599 0 0 1-.847-.847c-.24-.338-.41-.752-.9-2.026l-3.32-8.631Z"
    />
    <defs>
      <radialGradient
        id="a"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(132.614 -1.158 15.078) scale(12.0204)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCC34D" />
        <stop offset=".6" stopColor="#FCC34D" stopOpacity=".7" />
        <stop offset="1" stopColor="#FCC34D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="b"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(113.839 12.915 9.136) scale(16.6345)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCC34D" />
        <stop offset=".4" stopColor="#FCC34D" stopOpacity=".8" />
        <stop offset="1" stopColor="#FCC34D" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="c"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(3.814 -498.646 340.398) scale(15.9584)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFADAD" />
        <stop offset=".5" stopColor="#FFADAD" stopOpacity=".7" />
        <stop offset="1" stopColor="#FFADAD" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="d"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(-136.042 7.594 3.08) scale(13.7637)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFADAD" />
        <stop offset=".5" stopColor="#FFADAD" stopOpacity=".8" />
        <stop offset="1" stopColor="#FFADAD" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
